import React, { useState, useEffect, useRef } from "react";
import { AntdButton, DatePickerField } from "../../../blueplanitUtils/InputField";
import dayjs from "dayjs";
import { handleKeyDown } from "../../../blueplanitUtils/DatePickerAutoformate";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { GetTimeReports } from "../../../Slices/Thunk/Reports";
import { setLoader } from "../../../Slices/loaderSlice";
import { useDispatch } from "react-redux";
import { handleExport } from "./Export";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from "react-redux";
export const RecordTimeLog = () => {
    const dispatch = useDispatch();
    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
    const [currentPage, setCurrentPage] = useState(1);
    const [tableData, setTableData] = useState([]);
    const [totalCount, setCount] = useState([]);
    const dropdownRef = useRef(null);
    const startOfMonth = dayjs().startOf("month").toDate();
    const endOfMonth = dayjs().endOf("month").toDate();
    const data = useSelector((state) => state.Reports.AllRecords);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [form, setForm] = useState({})
    const [formattedData, setFormattedData] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const handleDateChange = (date, name) => {

        setForm(prev => ({
            ...prev,
            [name]: date ? dayjs(date).format("YYYY-MM-DD") : null
        }));
    };

    const handleSubmit = async () => {
        try {
            await dispatch(GetTimeReports({ ...form, loginUserId: loginUser?.id }));
            setCurrentPage(1)

            dispatch(setLoader(false));
        } catch (error) {

        }
    }
  

    const handleClear = async () => {
        try {
            setCurrentPage(1)
            const val = { startOfMonth, endOfMonth, page: 1, loginUserId: loginUser?.id };
            setTableData([]);
            await dispatch(GetTimeReports(val));
            setForm({});
        } catch (error) {
        }
    };
useEffect(() => {
          if(data?.length>0){
            const list = Array?.isArray(data) ? data : Array?.from(data); // ✅ normalize
            setCount(list?.length);
            setTableData(list);
            const exportFormatters = {
                startTime: val => val ? dayjs(parseInt(val)).format("DD/MM/YYYY h:mm a") : 'N/A',
                endTime: (val, rec) => val ? dayjs(parseInt(val)).format("DD/MM/YYYY h:mm a") : 'N/A',
                updatedTime: val => val ? dayjs(parseInt(val)).format("DD/MM/YYYY h:mm a") : 'N/A'
            };

            const columnKeys = columns?.map(col => col.key);
            setSelectedColumns(columnKeys);
           const  formattedData = list?.map(record => {
                const row = {};
                columns?.forEach(col => {
                    let value;
                    if (exportFormatters[col.dataIndex]) {
                        value = exportFormatters[col.dataIndex](record[col.dataIndex], record);
                    } else {
                        value = record[col.dataIndex];
                    }
                    row[col.key] = value; // use col.key for consistent headers
                });
                return row;
            });
            setFormattedData(formattedData);
        }
        },[data])

    useEffect(() => {
        (async () => {
            try {

                let val = {};
                if (Object.keys(form).length === 0) {
                    val = { startOfMonth, endOfMonth, page: currentPage, loginUserId: loginUser?.id };
                } else {
                    val = { ...form, page: currentPage, loginUserId: loginUser?.id };
                }
                await dispatch(GetTimeReports(val));

            } catch (error) {

            } finally {
                dispatch(setLoader(false));
            }


        })();
    }, []);

    useEffect(() => {
        (async () => {
            try {

                let val = {};
                if (Object.keys(form).length === 0) {
                    val = { startOfMonth, endOfMonth, page: currentPage, loginUserId: loginUser?.id };
                } else {
                    val = { ...form, page: currentPage, loginUserId: loginUser?.id };
                }
                await dispatch(GetTimeReports(val));
            } catch (error) {

            } finally {
                dispatch(setLoader(false));
            }
        })();
    }, [currentPage]);

    const columns = [
        {
            title: "From",
            dataIndex: "startTime",
            key: "startTime",
            align: "center",
            width: 120,
            render: (text) => dayjs(parseInt(text)).format("DD/MM/YYYY hh:mm a"),
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },
        {
            title: "To",
            dataIndex: "endTime",
            key: "endTime",
            align: "center",
            width: 120,
            render: (text) => dayjs(parseInt(text)).format("DD/MM/YYYY h:mm a"),
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },
        {
            title: "Request#",
            dataIndex: "requestId",
            key: "requestId",
            align: "center",
            width: 120,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },
        {
            title: "Date & Time Modified",
            dataIndex: "updatedTime",
            key: "updatedTime",
            align: "center",
            width: 150,
            render: (text) => text ? dayjs(parseInt(text)).format("DD/MM/YYYY hh:mm a") : 'N/A',
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },
        {
            title: "Modified by",
            dataIndex: "overriddenBy", // Update field name here
            key: "overriddenBy",
            align: "center",
            width: 150,

            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },
        {
            title: "Employee Email",
            dataIndex: "email", // Update field name here
            key: "email",
            align: "center",
            width: 180,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },
        {
            title: "Changed Area",
            dataIndex: "changedArea", // Update field name here
            key: "changedArea",
            align: "center",
            width: 180,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },
        {
            title: "Changed From",
            dataIndex: "previousTask", // Update field name here (assuming a 'previousValue' exists)
            key: "previousTask",
            align: "center",
            width: 180,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },
        {
            title: "Changed To",
            dataIndex: "currentTask", // Update field name here (assuming a 'currentValue' exists)
            key: "currentTask",
            align: "center",
            width: 160,
            onHeaderCell: () => ({
                style: { backgroundColor: "#007BFF", color: "white" },
            }),
        },

    ];

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="page-wrapper px-4">
            <div className="row align-items-center justify-content-between">
                {/* Inputs: Left Side */}
                <div className="col-md-5 d-flex">
                    <div className="flex-grow-1" style={{ marginTop: "10px" }}>
                        <DatePickerField
                            label="From"
                            classname="form-control"
                            name="from"
                            value={form?.from ? dayjs(form.from) : null}
                            format="DD/MM/YYYY"
                            onChange={(date) => handleDateChange(date, "from")}
                            onKeyDown={handleKeyDown}
                            style={{ width: "70%" }}
                            disabledDate={(current) => {
                                return (
                                    current &&
                                    (current > dayjs(form.to).startOf('day') || current > dayjs().endOf('day'))
                                );
                            }}

                        />
                    </div>
                    <div className="flex-grow-1" style={{ marginTop: "10px" }}>
                        <DatePickerField
                            label="To"
                            classname="form-control"
                            name="to"
                            value={form?.to ? dayjs(form.to) : null}
                            format="DD/MM/YYYY"
                            onChange={(date) => handleDateChange(date, "to")}
                            onKeyDown={handleKeyDown}
                            style={{ width: "70%" }}
                            disabledDate={(current) => {
                                return current && current < dayjs(form.from).startOf('day');
                            }}
                        />
                    </div>
                </div>
                <div className="col-md-5 d-flex justify-content-end gap-2 mt-2 mt-md-0">
                    <Tooltip title="Sync Now">
                        <FontAwesomeIcon icon={faSync}
                            style={{ fontSize: '24px', color: '#1890ff', cursor: 'pointer', marginRight: '7px', marginTop: '13px' }}
                            onClick={handleClear}
                        />
                    </Tooltip>
                    <AntdButton
                        variant="outlined"
                        size="medium"
                        label="Search"
                        type="primary"
                        onClick={handleSubmit}
                        style={{ backgroundColor: "#007bff", marginTop: "10px", color: "white" }}

                    />
                    <AntdButton
                        variant="outlined"
                        size="medium"
                        label="Clear"
                        onClick={handleClear}
                        type="primary"
                        color="success"
                        style={{ backgroundColor: "#837F7F", marginTop: "10px", color: "white" }}
                    />
                    <AntdButton
                        onClick={toggleDropdown}
                        type="primary"
                        label="Export"
                        size="medium"
                        style={{ marginTop: "10px" }}
                    />
                    {dropdownOpen && (
                        <ul
                            ref={dropdownRef}
                            className="dropdown-menu show"
                            style={{ display: "block", position: "absolute" }}
                        >
                            <li>
                                <AntdButton
                                    className="dropdown-item"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleExport("CSV", selectedColumns, formattedData);
                                    }}
                                    label={"CSV"}
                                />
                            </li>
                            <li>
                                <AntdButton
                                    className="dropdown-item"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleExport("PDF", selectedColumns, formattedData);
                                    }}
                                    label={"PDF"}
                                />
                            </li>
                        </ul>
                    )}
                </div>
            </div>

            <CustomGridTable
                columns={columns}
                Id="record-time-log-table"
                dataSource={tableData}
                rowKey="id"
                size="small"
                pagination={{
                    current: currentPage,
                    onChange: page => setCurrentPage(page),
                    total: totalCount,
                    showSizeChanger: false
                }}
                scroll={{ x: false }}
            />
        </div>
    )
}
